import { Dispatch, SetStateAction, useCallback } from 'react'
import { FirebaseDocRefType } from 'firebase/index'
import { StockUnionType } from 'types/stock'
import { DefaultStockType } from 'types/schedule'
import { getUpdateSchedulesFunction } from 'components/Templates/product/default/ProductEditDefaultTemplate'
import { StoreDefaultScheduleType } from 'types/storeDefault'

const useHandleDefaultStock = (
  setDailySchedules: Dispatch<SetStateAction<StoreDefaultScheduleType[]>>,
  setPreorderSchedules: Dispatch<SetStateAction<StoreDefaultScheduleType[]>>
): ((
  defaultStock: DefaultStockType,
  defaultStockIndex: number,
  scheduleRef?: FirebaseDocRefType,
  type?: StockUnionType
) => void) => {
  return useCallback(
    (
      defaultStock: DefaultStockType,
      defaultStockIndex: number,
      scheduleRef?: FirebaseDocRefType,
      type?: StockUnionType
    ) => {
      if (!type || !scheduleRef) return
      const update = getUpdateSchedulesFunction(type, setDailySchedules, setPreorderSchedules)
      if (!update) return
      update((prevState) => {
        const nextState = prevState
        const scheduleIndex = prevState.findIndex((prevState) => prevState.schedule_ref?.id === scheduleRef.id)
        nextState[scheduleIndex].default_stocks[defaultStockIndex] = defaultStock
        return [...nextState]
      })
    },
    [setDailySchedules, setPreorderSchedules]
  )
}

export default useHandleDefaultStock
